import { render, staticRenderFns } from "./ShareCollectionIconDialog.vue?vue&type=template&id=eff22d0c&scoped=true"
import script from "./ShareCollectionIconDialog.vue?vue&type=script&lang=js"
export * from "./ShareCollectionIconDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff22d0c",
  null
  
)

export default component.exports